import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

const ToggleButton = ({
  id,
  name,
  onClickToggle,
  initChecked,
  checkedText,
  uncheckedText,
  checkedColor,
  uncheckedColor,
  checkedIcon,
  unCheckedIcon,
  locked,
  value,
  ...properties
}) => {
  const [isChecked, setIsChecked] = useState(initChecked);

  return (
    <>
      <Button
        color={isChecked ? checkedColor : uncheckedColor}
        onClick={() => {
          !locked && setIsChecked(!isChecked);
          onClickToggle(!isChecked);
        }}
        startIcon={isChecked ? checkedIcon : unCheckedIcon}
        disabled={locked}
        {...properties}
      >
        {isChecked ? checkedText : uncheckedText}
      </Button>
      <Checkbox
        id={id}
        name={name}
        checked={isChecked || false}
        sx={{ display: 'none' }}
        disabled={properties.disabled || false}
        value={value}
      />
    </>
  );
};

ToggleButton.propTypes = {
  onClickToggle: PropTypes.func,
  initChecked: PropTypes.bool,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
  checkedColor: PropTypes.string,
  uncheckedColor: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  checkedIcon: PropTypes.node,
  unCheckedIcon: PropTypes.node,
  locked: PropTypes.bool,
  value: PropTypes.string,
};

export default ToggleButton;
